import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminApp } from "@/hooks/useAdminApp";
import { useStateMachineValue } from "@/core/arch/state_machine";
import { ROUTES } from "@/routes";
import { WizardProgress } from "./components/WizardProgress";
import { ContactStep } from "./wizard-steps/ContactStep";
import { BusinessStep } from "./wizard-steps/BusinessStep";
import { AddressStep } from "./wizard-steps/AddressStep";
import { ReviewStep } from "./wizard-steps/ReviewStep";

export function NewAccountWizard() {
  const { provisioningBloc } = useAdminApp();
  const [state] = useStateMachineValue(provisioningBloc);
  const navigate = useNavigate();

  useEffect(() => {
    provisioningBloc.reset();
  }, [provisioningBloc]);

  // Navigate to detail on successful completion
  useEffect(() => {
    if (state.result?.status === "completed" && state.result.provisionId) {
      const timer = setTimeout(() => {
        navigate(
          ROUTES.ACCOUNT_DETAIL.replace(":id", state.result!.provisionId!),
        );
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [state.result, navigate]);

  return (
    <div>
      <h1 className="text-foreground mb-6 text-2xl font-bold">
        New Terminal Account
      </h1>
      <div className="mb-8">
        <WizardProgress currentStep={state.wizardStep} />
      </div>
      <div className="bg-card rounded-lg border p-8">
        {state.wizardStep === "contact" && <ContactStep />}
        {state.wizardStep === "business" && <BusinessStep />}
        {state.wizardStep === "address" && <AddressStep />}
        {state.wizardStep === "review" && <ReviewStep />}
      </div>
    </div>
  );
}
